import EventSchedule from './EventSchedule';

export default EventSchedule;